import { Link } from "react-router-dom";
import Seo from "../components/Seo";

const NotFound = () => (
  <div data-testid="page-notfound" className="grain mesh-glow flex min-h-screen flex-col items-center justify-center px-6 text-center">
    <Seo title="Page not found" />
    <p className="font-mono text-xs uppercase tracking-[0.3em] text-emerald-300">404</p>
    <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
      This page has left the feed.
    </h1>
    <p className="mt-4 max-w-md text-sm text-emerald-100/60">
      The page you are looking for does not exist. Head back to the homepage or browse
      the product portfolio.
    </p>
    <div className="mt-8 flex gap-4">
      <Link to="/" data-testid="notfound-home-link" className="rounded-full bg-amber-500 px-6 py-3 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-night">
        Home
      </Link>
      <Link to="/products" data-testid="notfound-products-link" className="rounded-full border border-white/25 px-6 py-3 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-white">
        Products
      </Link>
    </div>
  </div>
);

export default NotFound;
